import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  fetchMe,
  updateUser,
} from '../../actions';

const currencyList = [
  { code: 'EURCENT', name: 'Euro' },
  { code: 'CENT', name: 'US Dollar' },
];

class General extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyHandle: '',
      pristine: true,
      currentTheme: 'DARK',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckToggle = this.handleCheckToggle.bind(this);
    this.handleThemeChange = this.handleThemeChange.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;

    let currencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    let currentTheme = 'DARK';
    if (localStorage.getItem('_vt_theme')) {
      currentTheme = localStorage.getItem('_vt_theme');
    }

    this.setState({
      currencyHandle,
      currentTheme
    });
  }

  handleChange(event) {
    this.setState({ currencyHandle: event.target.value, pristine: false });
    this.handleSubmit(event);
  }

  handleCheckToggle(item) {
    const { emailOnLogin, newsletter, currentTheme } = this.state;

    if (item === 'theme') {
      let themeEvent;
      if (currentTheme === 'DARK') {
        themeEvent = {
          target: {
            value: 'LIGHT'
          }
        };
        this.handleThemeChange(themeEvent)
        // this.setState({ emailOnLogin: !emailOnLogin, pristine: false });
      }
      if (currentTheme === 'LIGHT') {
        themeEvent = {
          target: {
            value: 'DARK'
          }
        };
        this.handleThemeChange(themeEvent)
        // this.setState({ currentTheme: !emailOnLogin, pristine: false });
      }
    }
  }

  handleSubmit(event) {
    // event.preventDefault();
    const { dispatch, user } = this.props;
    const { currencyHandle } = this.state;

    const data = {
      currencyHandle: event.target.value,
    };

    dispatch(updateUser(data)).then((res) => {
      if (res) dispatch(fetchMe());
    });

    this.setState({ pristine: true });
  }

  handleThemeChange(event) {
    const { currentTheme } = this.state;
    localStorage.setItem('_vt_theme', event.target.value);
    this.setState({currentTheme: event.target.value});
    window.location.reload();
  }

  render() {
    const { currencyHandle, pristine, currentTheme } = this.state;

    const currencyLoop = currencyList && currencyList.map((item, index) => {
      return (
        <option key={index} value={item.code}>{item.name}</option>
      );
    });

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="panel-label">
          General Settings
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x align-middle group">
              <div className="cell small-6 medium-6 large-6">
                <div className="gf-label">Theme</div>
              </div>
              <div className="cell small-6 medium-6 large-6 flex-end">
                <div
                  onClick={() => this.handleCheckToggle('theme')}
                  className={currentTheme === 'LIGHT' ? 'vlt-opt-switch on' : 'vlt-opt-switch off'}
                  >
                  <div>Light</div>
                  <div>Dark</div>
                </div>
              </div>
            </div>
            <hr />
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x align-middle group">
              <div className="cell small-6 medium-6 large-6">
                <div className="gf-label">Default Currency</div>
              </div>
              <div className="cell small-6 medium-6 large-6 flex-end">
                <div className="input-wrapper">
                  <select className="input i-pill" id="currencyHandle" value={currencyHandle} onChange={this.handleChange} placeholder="currencyHandle">
                    {currencyLoop}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(General);
